<svelte:options tag={null} />

<script lang="ts">
  export let visible = false;
  export let text: string;
</script>

<div class="mc-overlay-loader" class:is-visible={visible}>
  <div class="mc-loader mc-loader--l mc-loader--light">
    <span class="mc-loader__spinner">
      <svg
        class="mc-loader__icon"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 64 64"
      >
        <circle class="mc-loader__path" cx="50%" cy="50%" r="19" />
      </svg>
    </span>

    {#if text}
      <span class="mc-loader__text">
        {text}
      </span>
    {/if}
  </div>
</div>

<style lang="scss">
  @import '@mozaic-ds/styles/settings-tools/all-settings';
  @import '@mozaic-ds/styles/components/c.loader';
  @import '@mozaic-ds/styles/components/c.overlay';
</style>
